// extracted by mini-css-extract-plugin
export var container = "_5k-0";
export var icon = "_5k-1";
export var text = "_5k-2";